import { render, staticRenderFns } from "./CampaignSetup.vue?vue&type=template&id=237ec3d1&"
import script from "./CampaignSetup.vue?vue&type=script&lang=js&"
export * from "./CampaignSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports